import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { createRoot as u } from "react-dom/client";
import n from "./styles.module.less.js";
const t = h(
  (o, i) => {
    const { getTranslation: c } = o;
    return /* @__PURE__ */ d("div", { className: n.confirmModalWrapper, children: [
      /* @__PURE__ */ d("div", { ref: i, className: n.confirmModal, children: [
        /* @__PURE__ */ d("div", { className: n.confirmModalHeader, children: [
          /* @__PURE__ */ e("div", { className: n.confirmModalTitle, children: o.title }),
          /* @__PURE__ */ e("div", { className: n.confirmModalDescription, children: o.description })
        ] }),
        /* @__PURE__ */ d("div", { className: n.confirmModalFooter, children: [
          /* @__PURE__ */ e("button", { onClick: o.onCancel, children: c("confirm.cancel") }),
          /* @__PURE__ */ e("button", { onClick: o.onConfirm, children: c("confirm.yes") })
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: n.confirmModalBackground })
    ] });
  }
), N = ({
  title: o,
  description: i,
  onConfirm: c,
  getTranslation: m
}) => {
  const r = document.createElement("div");
  document.body.appendChild(r);
  const l = u(r);
  document.body.style.overflow = "hidden";
  const s = () => {
    c(), a();
  }, f = () => {
    a();
  }, a = () => {
    l.unmount(), document.body.removeChild(r), document.body.style.overflow = "auto";
  };
  l.render(
    /* @__PURE__ */ e(
      t,
      {
        title: o,
        description: i,
        onConfirm: s,
        onCancel: f,
        getTranslation: m
      }
    )
  );
};
t.displayName = "ConfirmModal";
export {
  t as ConfirmModal,
  N as confirm
};
